export default {
  setLoaded({ commit }, loaded) {
    commit('setLoaded', loaded)
  },
  setNominees({ commit }, nominees) {
    commit('setNominees', nominees)
  },
  setCategories({ commit }, nominees) {
    commit('setCategories', nominees)
  },
  setRounds({ commit }, nominees) {
    commit('setRounds', nominees)
  },
  selectNominee({ commit }, { categoryId, nomineeId }) {
    commit('selectNominee', { categoryId, nomineeId })
  },
  addSuggestion({ commit }, { categoryId, suggestionName }) {
    commit('addSuggestion', { categoryId, suggestionName })
  },
  clearSelected({ commit }) {
    commit('clearSelected')
  },
  clearCategory({ commit }, { categoryId }) {
    commit('clearCategory', { categoryId })
  },
  setSelectedChannelId({ commit }, { categoryId, tagId }) {
    commit('setSelectedChannelId', { categoryId, tagId })
  },
  setSelectedDayPartId({ commit }, { categoryId, tagId }) {
    commit('setSelectedDayPartId', { categoryId, tagId })
  },
  setKeyword({ commit }, { categoryId, keyword }) {
    commit('setKeyword', { categoryId, keyword })
  },
  setSortType({ commit }, { categoryId, sortType }) {
    commit('setSortType', { categoryId, sortType })
  },
  setAllowSuggestions({ commit }, allowSuggestions) {
    commit('setAllowSuggestions', allowSuggestions)
  },
  setFailedFetch({ commit }, failed) {
    commit('setFailedFetch', { failed })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js